import React, { PureComponent } from 'react';
import moment from 'moment';
import Label from '../../../../components/svg/Label';
import { getHexColorString, getOpacityFromRgba } from '../../../../helpers/helpers';
import FieldWrapper from './FieldWrapper';
import TimeModal from '../../Editors/TimeModal';
import { convertFieldFormatToMoment } from '../../../../helpers/DateTimeUtility';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';

export interface TimeFieldProps {
  valueUpdated: ValueChangedForFieldFunc;
  id?: string;
  fieldId?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  align?: string;
  foregroundColor?: TypeMePlease;
  backgroundColor?: TypeMePlease;
  fontName?: string;
  fontSize?: number;
  padding?: number;
  editable?: boolean;
  value?: string;
  fieldType?: number;
  dateTimeFormat?: string;
  useCurrent?: boolean;
}

export default class TimeField extends PureComponent<TimeFieldProps, TypeMePlease> {
  constructor(props) {
    super(props);

    this.mouseDown = this.mouseDown.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);

    this.state = { pickerOpen: false };
  }

  mouseDown() {
    if (!this.props.value && this.props.useCurrent) {
      const dateFormat = convertFieldFormatToMoment(this.props.dateTimeFormat);
      const newValue = moment();
      this.props.valueUpdated({ value: newValue.format(dateFormat) });
    } else {
      this.setState({ pickerOpen: !this.state.pickerOpen });
    }
  }

  handleDateChange(formatedDate: string) {
    this.props.valueUpdated({ value: formatedDate });
    this.setState({ pickerOpen: false });
  }

  handleModalClose() {
    this.setState({ pickerOpen: false });
  }

  render() {
    let picker = null;
    if (this.state.pickerOpen) {
      picker = (
        <TimeModal
          fieldType={this.props.fieldType}
          value={this.props.value}
          onChanged={this.handleDateChange}
          onClose={this.handleModalClose}
          dateTimeFormat={this.props.dateTimeFormat}
        />
      );
    }

    return (
      <FieldWrapper
        onMouseDown={this.mouseDown}
        x={this.props.x}
        y={this.props.y}
        w={this.props.w}
        h={this.props.h}
        backgroundColor={this.props.backgroundColor}
        editable={this.props.editable}
        id={this.props.id}
        fieldId={this.props.fieldId}
      >
        <Label
          text={this.props.value}
          fontName={this.props.fontName}
          fontSize={this.props.fontSize}
          width={this.props.w}
          align={this.props.align}
          padding={this.props.padding}
          foregroundColor={getHexColorString(this.props.foregroundColor)}
          foregroundColorOpacity={getOpacityFromRgba(this.props.foregroundColor)}
        />
        {picker}
      </FieldWrapper>
    );
  }
}
